module.exports = __webpack_public_path__ + "static/Call-Back-Request-8a54081d9a0b979b646e8191abb5600d.png";